<template>
  <div class="mt-2">
    <div class="d-flex orders-navigation">
      <button @click="ordersView = 'inCall'" class="btn btn-sm" :class="{'btn-primary': ordersView === 'inCall', 'btn-outline-info': ordersView !== 'inCall'}">
        <span class="d-inline d-md-none">L&nbsp;</span>
        <span class="d-none d-md-inline">Live</span>
      </button>
      <button @click="ordersView = 'live'" class="btn btn-sm ml-2" :class="{'btn-primary': ordersView === 'live', 'btn-outline-primary': ordersView !== 'live'}">
        <span class="d-inline d-md-none">C&nbsp;</span>
        <span class="d-none d-md-inline">Confirmate</span>
      </button>
      <button @click="ordersView = 'finished'" class="btn btn-sm ml-2" :class="{'btn-primary': ordersView === 'finished', 'btn-outline-success': ordersView !== 'finished'}">
        F<span class="d-none d-md-inline">inal</span>
      </button>
      <button @click="ordersView = 'canceled'" class="btn btn-sm ml-2" :class="{'btn-primary': ordersView === 'canceled', 'btn-outline-danger': ordersView !== 'canceled'}">
        A<span class="d-none d-md-inline">nulat</span>
      </button>
    </div>
    <div ref="sidebar" class="SideBar">
      <InCallOrders v-show="ordersView === 'inCall'" :orders-view="ordersView"></InCallOrders>
      <OrdersByState key="live" v-show="ordersView === 'live'" type="live" :orders-view="ordersView" @mounted="scrollToTop" />
      <OrdersByState key="finished" v-show="ordersView === 'finished'" type="finished" :orders-view="ordersView" @mounted="scrollToTop" />
      <OrdersByState key="canceled" v-show="ordersView === 'canceled'" type="canceled" :orders-view="ordersView" @mounted="scrollToTop" />
    </div>
  </div>
</template>

<script>

import InCallOrders from '@/components/dashboard/Operator/Orders/InCallOrders'
import OrdersByState from '@/components/dashboard/Operator/Orders/OrdersByState.vue'

export default {
  name: 'SideBar',
  components: {
    OrdersByState,
    InCallOrders
  },
  data () {
    return {
      ordersView: 'inCall',
      ordersStatistics: {
        inCallOrdersCount: 0,
        liveOrdersCount: 0,
        finishedOrdersCount: 0,
        canceledOrdersCount: 0
      },
      updateInterval: null
    }
  },
  beforeDestroy () {
    clearInterval(this.updateInterval)
  },
  methods: {
    scrollToTop () {
      this.$refs.sidebar.scrollTo({ top: 0 })
    }
  }
}
</script>

<style scoped>
.orders-navigation {
  padding: 0 10px;
}
</style>
